import(/* webpackMode: "eager" */ "/codebuild/output/src2238930513/src/dharmayana-website/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2238930513/src/dharmayana-website/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2238930513/src/dharmayana-website/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2238930513/src/dharmayana-website/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2238930513/src/dharmayana-website/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2238930513/src/dharmayana-website/src/components/AppCtaTracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2238930513/src/dharmayana-website/src/components/StoreLinkRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2238930513/src/dharmayana-website/src/components/WebVitals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppContextProvider"] */ "/codebuild/output/src2238930513/src/dharmayana-website/src/contexts/AppContext.tsx");
